/* eslint-disable prettier/prettier */
// data.js
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images (default avatar)
import defaultAvatar from "assets/images/team-2.jpg";

// API
import { getClioData } from "apis/api";

export default async function authorsTableData(filters = {}) {
  const { issuedAfter, issuedBefore } = filters;

  try {
    const response = await getClioData(issuedAfter, issuedBefore, "bills");
    const billsData = response


    const rows = billsData.data.map((bill) => ({
      number: bill.number || "",
      issued_at: bill.issued_at || "",
      created_at: bill.created_at || "",
      due_at: bill.due_at || "",
      tax_rate: bill.tax_rate,
      secondary_tax_rate: bill.secondary_tax_rate,
      updated_at: bill.updated_at || "",
      type: bill.type || "",
      start_at: bill.start_at || "",
      end_at: bill.end_at || "",
      balance: bill.balance || "",
      state: bill.state || "",
      kind: bill.kind || "",
      total: bill.total || "",
      paid: bill.paid,
      paid_at: bill.paid_at || "",
      pending: bill.pending,
      due: bill.due || "",
      credits_issued: bill.credits_issued,
      services_secondary_tax: bill.services_secondary_tax,
      services_sub_total: bill.services_sub_total || "",
      services_tax: bill.services_tax,
      services_taxable_sub_total: bill.services_taxable_sub_total,
      services_secondary_taxable_sub_total: bill.services_secondary_taxable_sub_total,
      taxable_sub_total: bill.taxable_sub_total,
      secondary_taxable_sub_total: bill.secondary_taxable_sub_total,
      sub_total: bill.sub_total,
      tax_sum: bill.tax_sum,
      secondary_tax_sum: bill.secondary_tax_sum,
      total_tax: bill.total_tax,
      available_state_transitions_0: bill?.available_state_transitions[0] || "",
      client_id: bill?.client?.id,
      client_name: bill?.client?.name || "",
      client_initials: bill?.client?.initials || "",
      client_type: bill?.client?.type || "",
      client_etag: bill?.client?.etag || "",
      matters_0_id: bill?.matters[0]?.id || "",
      matters_0_display_number: bill?.matters[0]?.display_number || "",
      matters_0_etag: bill?.matters[0]?.etag || "",
      user_id: bill?.user?.id,
      user_etag: bill?.user?.etag || "",
      user_name: bill?.user?.name || "",
    }));

    const columns = [
      { Header: "number", accessor: "number", align: "center" },
      { Header: "issued_at", accessor: "issued_at", align: "center" },
      { Header: "created_at", accessor: "created_at", align: "center" },
      { Header: "due_at", accessor: "due_at", align: "center" },
      { Header: "tax_rate", accessor: "tax_rate", align: "center" },
      { Header: "secondary_tax_rate", accessor: "secondary_tax_rate", align: "center" },
      { Header: "updated_at", accessor: "updated_at", align: "center" },
      { Header: "type", accessor: "type", align: "center" },
      { Header: "start_at", accessor: "start_at", align: "center" },
      { Header: "end_at", accessor: "end_at", align: "center" },
      { Header: "balance", accessor: "balance", align: "center" },
      { Header: "state", accessor: "state", align: "center" },
      { Header: "kind", accessor: "kind", align: "center" },
      { Header: "total", accessor: "total", align: "center" },
      { Header: "paid", accessor: "paid", align: "center" },
      { Header: "paid_at", accessor: "paid_at", align: "center" },
      { Header: "pending", accessor: "pending", align: "center" },
      { Header: "due", accessor: "due", align: "center" },
      { Header: "credits_issued", accessor: "credits_issued", align: "center" },
      { Header: "services_secondary_tax", accessor: "services_secondary_tax", align: "center" },
      { Header: "services_sub_total", accessor: "services_sub_total", align: "center" },
      { Header: "services_tax", accessor: "services_tax", align: "center" },
      { Header: "services_taxable_sub_total", accessor: "services_taxable_sub_total", align: "center" },
      { Header: "services_secondary_taxable_sub_total", accessor: "services_secondary_taxable_sub_total", align: "center" },
      { Header: "taxable_sub_total", accessor: "taxable_sub_total", align: "center" },
      { Header: "secondary_taxable_sub_total", accessor: "secondary_taxable_sub_total", align: "center" },
      { Header: "sub_total", accessor: "sub_total", align: "center" },
      { Header: "tax_sum", accessor: "tax_sum", align: "center" },
      { Header: "secondary_tax_sum", accessor: "secondary_tax_sum", align: "center" },
      { Header: "total_tax", accessor: "total_tax", align: "center" },
      { Header: "available_state_transitions_0", accessor: "available_state_transitions_0", align: "center" },
      { Header: "client_id", accessor: "client_id", align: "center" },
      { Header: "client_name", accessor: "client_name", align: "center" },
      { Header: "client_initials", accessor: "client_initials", align: "center" },
      { Header: "client_type", accessor: "client_type", align: "center" },
      { Header: "client_etag", accessor: "client_etag", align: "center" },
      { Header: "matters_0_id", accessor: "matters_0_id", align: "center" },
      { Header: "matters_0_display_number", accessor: "matters_0_display_number", align: "center" },
      { Header: "matters_0_etag", accessor: "matters_0_etag", align: "center" },
      { Header: "user_id", accessor: "user_id", align: "center" },
      { Header: "user_etag", accessor: "user_etag", align: "center" },
      { Header: "user_name", accessor: "user_name", align: "center" },
    ];

    return { columns, rows, billsData };
  } catch (error) {
    console.error("Error in authorsTableData:", error);
    return { columns: [], rows: [] };
  }
}
